package org.matthewo.table.games

import org.matthewo.api.EventCompetition
import org.matthewo.api.MetricsAPI
import org.matthewo.schema.MetricsMeta
import org.matthewo.schema.names
import org.matthewo.styles.color
import org.matthewo.table.RecordsTable

@Suppress("FunctionName")
fun <N : Number, M : MetricsAPI<N>> GameRecordsTable(
    year: Int,
    meta: MetricsMeta<in M>,
) = RecordsTable(
    year,
    [
        "OPRN" to EventCompetition<N, M?>::oprn,
        "OPR" to EventCompetition<N, M?>::opr,
        "Avg" to EventCompetition<N, M?>::mean,
        "SD" to EventCompetition<N, M?>::stdev,
        "Min" to EventCompetition<N, M?>::min,
        "Max" to EventCompetition<N, M?>::max,
    ],
    meta.names().entries.map { it.value to it.key },
    meta.periods.values.map { it.color() },
)
